import React from 'react';
import PropTypes from 'prop-types';
import {Card, Col, FormLabel, Row} from "react-bootstrap";
import HorizontalFormInput from "../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../components/common/horizontal-form-inputs/HorizontalFormDate";

const DetailsTab = ({fileName, downloadUrl, linesOfService}) => {
    return (
        <Card>
            <Card.Body className={"bg-light"}>
                <Row className={"mb-1"}>
                    <Col xs={7} sm={3}>
                        <p className={"false-label form-label col-form-label"}>Download File</p>
                    </Col>
                    <Col>
                        <a id={"fileName"} href={downloadUrl}>{fileName}</a>
                    </Col>
                </Row>
                <HorizontalFormInput controlId={"legalContractLinesOfService[0].linesOfService.contract.name"} label={"Contract"} readMode={true} />
                <Row className={"mb-1"}>
                    <Col xs={7} sm={3}>
                        <p className={"false-label sform-label col-form-label"}>Lines of Service</p>
                    </Col>
                    <Col>
                        <p id={"linesOfService"} className={"form-control-plaintext"}>
                        {linesOfService.map((l, index) => {
                            return l.lineOfService.name
                        }).join(', ')}
                        </p>
                    </Col>
                </Row>
                <HorizontalFormInput controlId={"createdBy.userName"} label={"Created By"} readMode={true} />
                <HorizontalFormDate controlId={"createdOn"} label={"Created On"} readMode={true} />
            </Card.Body>
        </Card>
    )
}
DetailsTab.defaultProps = {}
DetailsTab.propTypes = {}
export default DetailsTab